var jade = require("/web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (view) {
buf.push("<div class=\"modal-dialog game\"><div class=\"background-wrapper\"><div class=\"modal-content\"><div class=\"modal-header\">");
if ( view.closeButton)
{
buf.push("<div type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"button close\">&times;</div>");
}
if ( view.options.headerContent)
{
buf.push("<h3>" + (null == (jade_interp = view.options.headerContent) ? "" : jade_interp) + "</h3>");
}
else
{
buf.push("<h3>man bites God</h3>");
}
buf.push("</div><div class=\"modal-body\">");
if ( view.options.bodyContent)
{
buf.push("<div>" + (null == (jade_interp = view.options.bodyContent) ? "" : jade_interp) + "</div>");
}
else
{
buf.push("<p>Man Bites God are the bad boys of the Melbourne live music and comedy scene. It is like being drowned in a bathtub of harmony.</p><img src=\"http://www.manbitesgod.com/images/picturecoupleb.jpg\"><img src=\"http://www.manbitesgod.com/images/manrantb.jpg\">");
}
buf.push("</div><div class=\"modal-body wait secret\"><h3>Reticulating Splines...</h3><div class=\"progress progress-striped active\"><div class=\"progress-bar\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" data-i18n=\"modal.okay\" class=\"btn btn-primary\">Okay</button></div></div></div></div>");}.call(this,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/modal-base.jade
// module id = 798
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91